import React from "react";
import './NumericSpinBox.css';

const NumericSpinBox = ({ value, onChange, min, max }) => {

  const handleIncrement = () => {
    console.log(value);
    onChange(Math.min(value + 1, max));
  };

  const handleDecrement = () => {
    onChange(Math.max(value - 1, min));
  };

  return (
    <div className="spinbox-input">
      <div className="spinbox-number" style={{ maxWidth: 98 }} disabled>{value}</div>
      <div className="spinbox-controls">

        <div className="spinbox-minus accent-dark-bg" onClick={handleDecrement}>
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 12.998H5v-2h14z"/>
          </svg>
        </div>

        <div className="spinbox-plus accent-dark-bg" onClick={handleIncrement}>
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"/>
          </svg>
        </div>

      </div>
    </div>
  );
}

export default NumericSpinBox;